// types
import { CompanySubscriptionLevel } from 'types/graphql'

export const LICENCES_TYPES = {
  USER: 'USER',
  ENTERPRISE: 'ENTERPRISE'
}

export const LICENCES_NAMES = {
  STRATEGY: 'STRATEGY',
  TRACKING: 'TRACKING',
  INTELLIGENCE: 'INTELLIGENCE',
  FORMS: 'FORMS'
}

export const LICENCE_TYPES_OPTIONS = [
  {
    label: 'Per User',
    value: LICENCES_TYPES.USER
  },
  {
    label: 'Enterprise',
    value: LICENCES_TYPES.ENTERPRISE
  }
]

export const SUBSCRIPTION_LEVEL_OPTIONS = [
  { label: 'Standard', value: CompanySubscriptionLevel.Standard },
  { label: 'Professional', value: CompanySubscriptionLevel.Professional },
  { label: 'Enterprise', value: CompanySubscriptionLevel.Enterprise }
]
